import React, { useEffect, useState } from "react";
import { FilaOperador } from './components/fila-operador'
import { FilaEspera } from './components/fila-espera'
import { FilaFinalizados } from './components/fila-finalizados'
import { useQuery } from "@tanstack/react-query";
import { apiModulo } from "../../../services/api";


interface ChannelProps {
  id_channel: number;
  channel: string
}

export const FilaAtendimento = () => {
  const [channel, setChannel] = useState<number>();

  const [checkbox, setCheckbox] = useState("Em aberto");

  const { data } = useQuery({ queryKey: ['canais'], queryFn: async () => await apiModulo.get('/filters/channels') })

  return (
    <>
      <div className=" flex h-full w-[34%] overflow-x-hidden rounded-md bg-white py-2 ">
        <div className="flex w-full flex-col items-center overflow-y-hidden ">
          <h1 className="text-md -mb-2 mt-3 font-medium text-primary">
            Em Atendimento
          </h1>
          <div className="flex h-full w-full flex-col p-4 ">
            <FilaOperador />

            <hr className="my-4 h-0.5 w-full bg-gray-400" />

            <h1 className=" text-md mb-2 w-full text-center font-medium text-primary">
              Aguardando Atendimento
            </h1>
            <div className=" flex max-h-[50%] w-full flex-col">
              <div className=" mb-2 first:flex first:items-center first:justify-between ">
                <p className="text-xs 2xl:text-sm">Canal:</p>
                <select
                  className="  block rounded-md border border-gray-300 bg-gray-50 px-1 py-1 text-xs text-gray-500  outline-none 2xl:px-2.5 2xl:text-sm "
                  onChange={(e) => setChannel(Number(e.target.value))}
                >
                  <option value="">Todos</option>
                  {data?.data.channels.map((channel: ChannelProps) => (
                    <option value={channel.id_channel}>{channel.channel}</option>
                  ))}
                </select>

                <select
                  className="block rounded-md border border-gray-300 bg-gray-50 px-1 py-1 text-xs text-gray-500  outline-none 2xl:px-2.5 2xl:text-sm "
                  onChange={(e) => setCheckbox(e.target.value)}
                >
                  <option value="Em aberto">Apenas em aberto</option>
                  <option value="finalizados">Apenas finalizados</option>
                </select>
              </div>
            </div>
            {checkbox === "finalizados" ? (<FilaFinalizados id_channel={channel} />) : <FilaEspera id_channel={channel} />}
          </div>
        </div>

      </div>

    </>
  );
};
